export const numberToBrl = (n: number) => {
  return `R$ ${n
    .toFixed(2)
    .replace(/\./g, ',')
    .replace(/(\d)(?=(\d{3}){1,3},)/g, '$1.')}`;
};
